import { Flex } from '@acsbe/ui';
import { ColorContent } from './common';

export const CurrentPlanLabel = () => {
  return (
    <Flex
      scale="success"
      paddingBlock={2.5}
      paddingInlineEnd={4}
      paddingInlineStart={3}
      align="center"
      gap={0.5}
      self="stretch"
      stretch
      radius="sm"
    >
      <Flex row justify="center" align="center" gap={1} stretch>
        {/* <PlanActiveTick /> */}
        <ColorContent
          size="sm"
          emphasis="low"
          lineHeight={1.43}
          color="#06720F"
        >
          Current Plan
        </ColorContent>
      </Flex>
    </Flex>
  );
};
